<template>
  <b-modal id="manage-cookie-modal" ref="manageCookiesModal" :hide-header-close="false" hide-footer :no-close-on-backdrop="noCloseOnBackdrop" @hidden="hide()">
    <template slot="modal-title">
      <span class="header-text">Cookie Preferences</span>
    </template>
    <div class="cookie-information">
      <div class="row pb-24">
        <span class="cookie-policy-title">Cookie Policy</span>
        <span class="privacy-text">
          We use cookies to enhance your experience while browsing our website. Cookies are small text files that are stored on your device and allow us to remember your preferences, analyze traffic, and personalize content. We respect your privacy and want to give you control over the use of cookies on our website. You can manage your preferences by selecting the different categories of cookies
          below. Please note that disabling some cookies may affect the functionality of our website. For more information on how we handle your data, please refer to our Privacy Policy. Thank you for trusting us with your personal information.
        </span>
      </div>
      <div class="row pb-5">
        <span class="cookie-policy-title col-12">Manage Preferences</span>
      </div>

      <!-- Necessary Cookies -->
      <div class="row cookie-list" :class="expandCookieDetails.necessary ? 'expand-cookie-background' : ''">
        <i class="col-1 pt-4" :class="expandCookieDetails.necessary ? 'fa fa-minus expand-cookie' : 'fa fa-plus'" @click="expandCookieDetails.necessary = !expandCookieDetails.necessary"> </i>
        <span class="col-6 padding-cookie-sec" :class="expandCookieDetails.necessary ? 'expand-cookie' : ''">Necessary Cookies</span>
        <span class="col-5 text-right active-cookie-status">Always Active</span>
        <b-collapse id="collapse-necessary-cookies" class="pt-20 col-12 pl-0 pr-0" ref="necessaryCookie" v-model="expandCookieDetails.necessary">
          <b-table :items="necessaryCookies" outlined class="cookie-table"></b-table>
          <div class="outer-cookie-summery" v-for="(item, index) in necessaryCookies" :key="`cookie-${index}`">
            <div class="wrap-cookie-content">
              <h3>Cookie Name</h3>
              <p class="cookie-name-value">{{ item.cookie_name }}</p>
            </div>
            <div class="wrap-cookie-content">
              <h3>Provider</h3>
              <p>{{ item.provider }}</p>
            </div>
            <div class="wrap-cookie-content">
              <h3>Purpose</h3>
              <p>{{ item.purpose }}</p>
            </div>
            <div class="wrap-cookie-content">
              <h3>Expires</h3>
              <p>{{ item.expires }}</p>
            </div>
            <div class="wrap-cookie-content">
              <h3>Type</h3>
              <p>{{ item.type }}</p>
            </div>
          </div>
        </b-collapse>
      </div>

      <!-- Performance Cookies -->
      <div class="row cookie-list pb-0" :class="expandCookieDetails.performance ? 'expand-cookie-background' : ''">
        <i class="col-1 pt-4" :class="expandCookieDetails.performance ? 'fa fa-minus expand-cookie' : 'fa fa-plus'" @click="expandCookieDetails.performance = !expandCookieDetails.performance"></i>
        <span class="col-5 padding-cookie-sec" :class="expandCookieDetails.performance ? 'expand-cookie' : ''">Performance Cookies</span>
        <div class="switch-option col-6">
          <label class="switch">
            <input type="checkbox" disabled />
            <div class="slider round"></div>
          </label>
        </div>
        <b-collapse :id="generateCookieId('Performance Cookies')" ref="performanceCookie" v-model="expandCookieDetails.performance">
          <div class="col-12 no-cookies-text">
            <span>There are currently no cookies associated with this cookie type.</span>
          </div>
        </b-collapse>
      </div>

      <!-- Functional Cookies -->
      <div class="row cookie-list pb-0" :class="expandCookieDetails.functional ? 'expand-cookie-background' : ''">
        <i class="col-1 pt-4" :class="expandCookieDetails.functional ? 'fa fa-minus expand-cookie' : 'fa fa-plus'" @click="expandCookieDetails.functional = !expandCookieDetails.functional"></i>
        <span class="col-5 padding-cookie-sec" :class="expandCookieDetails.functional ? 'expand-cookie' : ''">Functional Cookies</span>
        <div class="switch-option col-6">
          <label class="switch">
            <input type="checkbox" disabled />
            <div class="slider round"></div>
          </label>
        </div>
        <b-collapse :id="generateCookieId('Functional Cookies')" ref="functionalCookie" v-model="expandCookieDetails.functional">
          <div class="col-12 no-cookies-text">
            <span>There are currently no cookies associated with this cookie type.</span>
          </div>
        </b-collapse>
      </div>

      <!-- Targeting Cookies -->
      <div class="row cookie-list pb-0" :class="expandCookieDetails.targeting ? 'expand-cookie-background' : ''">
        <i class="col-1 pt-4" :class="expandCookieDetails.targeting ? 'fa fa-minus expand-cookie' : 'fa fa-plus'" @click="expandCookieDetails.targeting = !expandCookieDetails.targeting"></i>
        <span class="col-5 padding-cookie-sec" :class="expandCookieDetails.targeting ? 'expand-cookie' : ''">Targeting Cookies</span>
        <div class="switch-option col-6">
          <label class="switch">
            <input type="checkbox" disabled />
            <div class="slider round"></div>
          </label>
        </div>
        <b-collapse :id="generateCookieId('Targeting Cookies')" ref="targetingCookie" v-model="expandCookieDetails.targeting">
          <div class="col-12 no-cookies-text">
            <span>There are currently no cookies associated with this cookie type.</span>
          </div>
        </b-collapse>
      </div>
    </div>
    <div class="row horizontal-divider"></div>
    <div class="row footer-buttons text-right pt-30">
      <div class="col-md-12 col-xs-12 pr-24">
        <b-button variant="primary" class="accept-cookies-btn" @click="saveCookieSettings()">Accept and Close</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import * as authService from "@/components/services/auth-service";
export default {
  name: "manage-cookies-modal",
  props: {
    //This can be either portal or pweb
    platformType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      noCloseOnBackdrop: true,
      necessaryCookies: [
        { cookie_name: "Real User Monitoring", provider: "Datadog", purpose: "This cookie is used for Session Tracking", expires: "When browser is closed", type: "First-Party" },
        { cookie_name: "_portal_necessary_cookies_accepted", provider: "THREAD", purpose: "Track acceptance of cookie policy - Portal", expires: "1 year", type: "First-Party" },
        { cookie_name: "_pweb_necessary_cookies_accepted", provider: "THREAD", purpose: "Track acceptance of cookie policy - Participant Web", expires: "1 year", type: "First-Party" }
      ],
      expandCookieDetails: {
        necessary: false,
        performance: false,
        functional: false,
        targeting: false
      }
    };
  },
  methods: {
    show() {
      this.$refs.manageCookiesModal.show();
    },
    hide() {
      this.$refs.manageCookiesModal.hide();
      if (!this.isCookiesAcceptedData()) {
        this.$root.$emit("showCookieBanner", true);
      }
      this.hideCookieData();
    },
    expandCookieInfo(cookieType) {
      if (cookieType === "necessary") {
        this.$set(this.expandCookieDetails, "necessary", !this.expandCookieDetails.necessary);
      } else if (cookieType === "performance") {
        this.$set(this.expandCookieDetails, "performance", !this.expandCookieDetails.performance);
      } else if (cookieType === "functional") {
        this.$set(this.expandCookieDetails, "functional", !this.expandCookieDetails.functional);
      } else if (cookieType === "targeting") {
        this.$set(this.expandCookieDetails, "targeting", !this.expandCookieDetails.targeting);
      }
    },
    getExpandCookieInfo(cookieType) {
      if (cookieType === "necessary") {
        return this.expandCookieDetails.necessary;
      } else if (cookieType === "performance") {
        return this.expandCookieDetails.performance;
      } else if (cookieType === "functional") {
        return this.expandCookieDetails.functional;
      } else if (cookieType === "targeting") {
        return this.expandCookieDetails.targeting;
      }
    },
    generateCookieId(cookieCategory) {
      let data = cookieCategory.replace(/ /g, "-");
      return "collapse-" + data.toLowerCase();
    },
    saveCookieSettings() {
      if (!this.isCookiesAcceptedData()) {
        authService.setNecessaryCookies(this.platformType);
      }
      this.hide();
    },
    isCookiesAcceptedData() {
      return authService.getCookiePreference(this.platformType);
    },
    hideCookieData() {
      let cookiesType = ["necessary", "performance", "functional", "targeting"];
      cookiesType.map(data => {
        if (this.getExpandCookieInfo(data)) {
          this.expandCookieInfo(data);
          if (data === "necessary") {
            this.$refs.necessaryCookie.toggle();
          }
          if (data === "performance") {
            this.$refs.performanceCookie.toggle();
          }
          if (data === "functional") {
            this.$refs.functionalCookie.toggle();
          }
          if (data === "targeting") {
            this.$refs.targetingCookie.toggle();
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">
#manage-cookie-modal {
  .modal-dialog {
    width: 600px;
    max-width: 700px !important;

    .modal-header {
      border: solid 1px #e0e0e0;
      padding-left: 32px;
    }

    .modal-content {
      .cookie-information {
        max-height: 575px;
        height: auto;
        overflow-y: auto;
        padding: 0px 20px 15px 20px;
        scrollbar-width: thin;
        /* "auto" or "thin"  */
        scrollbar-color: #e6e9ed transparent;

        /* scroll thumb & track */
        &::-webkit-scrollbar {
          width: 7px;
          /* width of the entire scrollbar */
        }

        &::-webkit-scrollbar-track {
          background: transparent;
          /* color of the tracking area */
        }

        &::-webkit-scrollbar-thumb {
          background-color: #9b9b9b;
          /* color of the scroll thumb */
          border-radius: 10px;
          /* roundness of the scroll thumb */
          border: 3px solid transparent;
          /* creates padding around scroll thumb */
        }
      }

      .header-text {
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4a4a4a;
      }

      .privacy-text {
        font-size: 14px;
        line-height: 1.43;
        color: #666669;
      }

      .accept-cookies-btn {
        padding: 8px 16px;
        border-radius: 4px;
        background-color: #4c8ce4;
        margin-left: 12px;
        font-size: 14px;
      }

      .cookie-policy-title {
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        color: #4a4a4a;
        padding: 15px 0px 20px 0px;
      }

      .cookie-list {
        padding: 16px;
        border-radius: 8px;
        border: solid 1px #e0e0e0;
        background-color: rgba(241, 241, 241, 0);
        max-height: 100%;
        height: auto;
        margin-bottom: 8px;

        .no-cookies-text {
          padding-bottom: 16px;
          padding-left: 56px;
        }

        .active-cookie-status {
          font-size: 14px;
          font-weight: 500;
          color: #00933b;
        }

        .cookie-table {
          background-color: #fff;
        }

        //Toggle button
        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border: 2px solid #ccc;
        }
        .switch-option {
          width: 100%;
          text-align: right;
        }
        .switch {
          position: relative;
          display: inline-block;
          width: 38px;
          height: 23px;
          margin-right: 10px;
          opacity: 0.5;
        }

        /* Hide default HTML checkbox */
        .switch input {
          display: none;
        }
        .slider:before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 2px;
          bottom: 1px;
          background-color: #ccc;
        }
        input:checked + .slider {
          border: 2px solid #48bf7a;
        }
        input:checked + .slider:before {
          content: "";
          background-color: #48bf7a;
        }
        input:focus + .slider {
          box-shadow: 0 0 1px #2196f3;
        }
        input:checked + .slider:before {
          position: absolute;
          color: #2ecc71;
          text-align: center;
          font-size: 20px;
          -webkit-transform: translateX(14px);
          -ms-transform: translateX(14px);
          transform: translateX(14px);
        }
        /* Rounded sliders */
        .slider.round {
          border-radius: 34px;
        }
        .slider.round:before {
          border-radius: 50%;
        }

        .expand-cookie {
          color: #3b527a;
        }
        .table {
          thead th {
            width: 102px;
            font-size: 12px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 1.33;
            letter-spacing: normal;
            color: #9b9b9b;
          }
          td {
            font-size: 13px;
            text-align: left;
            color: #666669;

            &:first-child {
              word-break: break-all;
              width: 285px;
            }
          }
        }
      }

      .expand-cookie-background {
        background-color: rgba(59, 82, 122, 0.03);
      }

      .outer-cookie-summery {
        display: none;
      }

      .horizontal-divider {
        border-bottom: 1px solid #e0e0e0;
        width: 105%;
        margin-left: -14px !important;
      }
    }
  }
}

/* Mobile View  */
@media (max-width: 560px) {
  #manage-cookie-modal {
    .modal-dialog {
      width: auto;
      min-width: auto !important;

      .cookie-list {
        display: inline-block;
        width: 100%;
        max-height: 100% !important;

        .padding-cookie-sec {
          padding: 0px 5px 0px 5px;
        }

        i {
          padding-left: 0px;
        }

        .switch-option {
          padding: 0;
          float: right;
          width: 16% !important;
        }

        .active-cookie-status {
          padding: 0;
          float: right;
          width: auto;
        }

        .no-cookies-text {
          padding-left: 28px !important;
          padding-right: 0;
          padding-top: 20px;
        }

        .cookie-table {
          display: none;
        }

        .outer-cookie-summery {
          display: block;
          border: 1px solid #e4e8eb;
          border-radius: 8px;
          padding: 16px;
          box-sizing: border-box;
          background: #fff;
          margin-top: 8px;

          .wrap-cookie-content {
            display: flex;
            align-items: baseline;

            h3 {
              width: 178px;
              margin-right: 16px;
              color: #9b9b9b;
              font-size: 12px;
              width: 36%;
              font-family: "roboto-bold";
            }

            p {
              color: #666669;
              font-size: 14px;
              width: 56%;
              font-family: "roboto-regular";
              margin-bottom: 8px;
            }

            .cookie-name-value {
              word-break: break-all;
            }
          }
        }
      }

      .footer-buttons {
        text-align: right !important;
        padding-right: 0px;
      }
    }
  }
}
</style>
